import type { ModeType } from "~/components/prompt/PromptBar.types";

/**
 * Generate appropriate placeholder text based on the selected mode
 */
export const generatePlaceholderText = (mode: ModeType): string => {
  switch (mode) {
    case "chat":
      return "Ask anything to make your data actionable...";
    case "agent":
      return "What are you trying to accomplish?";
    case "workflow":
      return "Define a workflow and automate your process...";
    default:
      return "Ask anything to make your data actionable...";
  }
};
